import { Utilisateur } from './../../../../models/utilisateur.model';
import { AssocUtilisateurFermeService } from './../../../../services/assocutilisateurferme.service';
import { AssocUtilisateurFerme } from './../../../../models/assocutilisateurferme.model';
import { TranslateService } from '@ngx-translate/core';
import { FermeService } from './../../../../services/ferme.service';
import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { Periode } from '../../../../models/periode.model';
import { Recette } from '../../../../models/recette.model';
import { ModificationRecetteComponent } from '../modificationRecette/modificationRecette.component';
import { Ferme } from '../../../../models/ferme.model';
import { User } from '../../../../@core/data/users';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-AUFDialog',
  templateUrl: './AUFDialog.component.html',
  styleUrls: ['./AUFDialog.component.scss']
})
export class AUFDialogComponent implements OnInit {
  @Input() selectedUser: Utilisateur;
  fermes: Ferme[];
  grantedFermes: AssocUtilisateurFerme[];
  associatedFarms: String;
  confirm: String;
  cancel: String;
  assocTab: Array<number>;
    constructor(private translate: TranslateService,
              protected ref: NbDialogRef<AUFDialogComponent>,
              private AUFService: AssocUtilisateurFermeService,
              private toastrService: NbToastrService,
              private fermeService: FermeService) {
      this.translate.get('ASSOCIATED_FARMS').subscribe((res: string) => {
        this.associatedFarms = res;
      });
      forkJoin(this.translate.get('ASSOCIATED_FARMS'),
               this.translate.get('CANCEL'),
               this.translate.get('CONFIRM'))
      .subscribe((res: any) => {
        this.associatedFarms = res[0];
        this.cancel = res[1];
        this.confirm = res[2];
      });
      this.assocTab = [];
  }

  ngOnInit() {
    forkJoin(this.fermeService.getFermes(), this.fermeService.getGrantedFermes(this.selectedUser.id))
      .subscribe((res: any) => {
        this.fermes = res[0]
        this.grantedFermes = res[1];
        this.grantedFermes.forEach(grantedFerme => {
          this.assocTab.push(grantedFerme.fermeId);
        });
    });
  }


  getGrantedAccess(fermeId: number) {
    return this.grantedFermes.some(e => e.fermeId === fermeId);
  }

  toggle(fermeId: number, checked: boolean) {
    if(checked){
      this.assocTab.push(fermeId);
    }else{
      const index: number = this.assocTab.indexOf(fermeId);
      if (index !== -1) {
          this.assocTab.splice(index, 1);
      }
    }
  }

  modify() {
    forkJoin(this.AUFService.delete_auf(this.selectedUser.id), this.AUFService.update_auf(this.selectedUser.id, this.assocTab))
      .subscribe((res: any) => {
          this.toastrService.success(this.translate.instant('AUF_ADDED'),
          this.translate.instant('SUCCESS'));
          this.ref.close();
      });
  }
  dismiss() {
    this.ref.close();
  }
}
